import { Inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { StateService } from '@uirouter/core';
import { EMPTY, Observable, Subscription, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { CimaUrl } from '../cima/url';
import { IXMOptions } from 'core/interfaces';
import { AccountLockedErrorCode, CONFIG_TOKEN, CORE_API_LIST } from 'core/constants';
import { HttpError } from './error';
import { LoggerService } from './logger';
import { Modal, XmStore, XmStoreUtil } from 'core/services';
import { CmsMyAccount } from 'store/cms/models';

@Injectable()
export class GenericErrorInterceptor implements HttpInterceptor {
    public apiFailureModalData: DescriptiveModalData;
    public cmsMyAccount: CmsMyAccount;

    private config: IXMOptions;
    private state: StateService;
    private cimaUrl: CimaUrl;
    private logger: LoggerService;
    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];
    private apiError: string = '';
    private modal: Modal;

    constructor(state: StateService, cimaUrl: CimaUrl, @Inject(CONFIG_TOKEN) config: IXMOptions, logger: LoggerService, modal: Modal, xmStore: XmStore) {
        Object.assign(this, { state, cimaUrl, config, logger, modal, xmStore });
    }

    public intercept(request: HttpRequest<object>, next: HttpHandler): Observable<HttpEvent<object>> {
        const startTime: number = performance.now();

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                this.logger.error(error, request, startTime);
                if (error.status === 401 && (error.url.includes(this.config.GATEWAY_BASE_URL))) {
                    this.cimaUrl.redirectToLogin({ state: this.state.current.name, params: this.state.params });

                    return EMPTY;
                } else if (error.status === 423) {
                    if (error?.error?.errorCode === AccountLockedErrorCode.NM_TO_XM_UPGRADE_INPROGRESS) {
                        this.state.go('account-upgrade-error');
                    } else {
                        this.state.go('account-error');
                    }
                    
                    return EMPTY;
                } else if (error.status >= 400 && window.document.documentElement.getElementsByClassName('mat-dialog-container').length < 1) {
                    this.apiError = new URL(error.url).pathname;
                    const err: boolean = CORE_API_LIST.some((e: string) => this.apiError === e);
                    if (err) {
                        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsMyAccount>(CmsMyAccount), (cmsMyAccount: CmsMyAccount) => {
                            this.cmsMyAccount = cmsMyAccount;
                            this.apiFailureModalData = cmsMyAccount.apiFailureModalData;
                            this.modal.descriptive(this.apiFailureModalData);
                        }));
                    }

                    return throwError(new HttpError(error));
                } else {
                    return throwError(new HttpError(error));
                }
            })
        );
    }
}
